<template>
	<div class="perc_container">
		<div class="perc_bar" :style="bar_style"></div>
		<div :class="$vuetify.breakpoint.xs ? 'perc_value_xs':'perc_value'">{{ value.toFixed(2) }} %</div>
	</div>
</template>

<script>
export default {
	data() {
		return {

		};
	},
	props: {
		value: {
			type: Number,
			default: 0.0
		},
		lowcolor: {
			type: String,
			default: '#C4DA9D'
		},
		undercolor: {
			type: String,
			default: '#DDDDDD'
		},
		overcolor: {
			type: String,
			default: '#E6B5B5'
		},
	},
	computed: {
		bar_style() {
			let style='';
			if (this.value == 0) {
				style += 'width: 100%;';
			} else if (this.value < 75.0) {
				style += 'background-color: ' + this.lowcolor + ';';
				style += 'width: ' + this.value.toFixed(2) + '%;';
			} else if (this.value <= 100.0) {
				style += 'background-color: ' + this.undercolor + ';';
				style += 'width: ' + this.value.toFixed(2) + '%;';
			} else {
				style += 'background-color: ' + this.overcolor + ';';
				style += 'width: 100%;';
			}

			return style;
		}
	},
	methods: {

	}
}
</script>

<style lang="scss" scoped>
.perc_container {
	position: relative;
	width: 100%;
	height: 100%;
}

.perc_bar {
	position: absolute;
	top: 0px;
	left: 0px;
	height: 100%;
	z-index: 10;
}

.perc_value {
	position: relative;
	top: calc(50% - 11px);
	height: 100%;
	left: 5px;
	z-index: 12;
	width: 100%;
}
.perc_value_xs {
	position: relative;
	top: calc(50% - 11px);
	height: 100%;
	left: 0;
	z-index: 12;
	width: 100%;
}
</style>
